<template>
    <div class="mt-4">
        <b-row>
            <b-col lg="12" md="12" sm="12">
                <div class="table-responsive">
                    <table class="table table-striped detail-table">
                        <tbody>
                        <tr v-for="(row, index) in filtered_appointment" :key="index">
                            <td class="detail-table-label">{{index | rowTitleFormat }}</td>
                            <td>{{row}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
  import TableDataExcluder from '@/mixins/table-data-excluder';

  export default {
    props: {
      appointment: {
        type: Object
      }
    },
    mixins: [TableDataExcluder],
    data() {
      return {
        excludeFields: [
          'id',
          'doctor_id',
          'patient_id',
          'prescription_id',
          'patient',
          'doctor',
          'prescription',
          'vital_id',
          'lab_exam',
          'lab_exam_id',
          'vital'
        ]
      }
    },

    computed: {
      filtered_appointment() {
        return this.excluder(this.appointment, this.excludeFields);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Appointment/Detail/Tabs/AppointmentTab.vue